<template>
  <v-card class="px-5 py-3 rounded-lg elevation-0 mb-4" outlined>
    <template v-if="!selectedLead">
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2"
            >mdi-file-document-outline</v-icon
          >
          <div class="text-h6 font-weight-bold">Visit Details</div>
        </div>
      </div>
      <div class="text-center py-8 grey--text">
        <v-icon size="48" color="grey lighten-2" class="mb-2">
          mdi-information-outline
        </v-icon>
        <div>No visit information available</div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-space-between align-center mb-2">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2"
            >mdi-file-document-outline</v-icon
          >
          <div class="text-h6 font-weight-bold">Lead Details</div>
        </div>
        <Barcode
          v-if="selectedLead.barcode"
          small
          :barcode="selectedLead.barcode"
          :id="Number(selectedLead.id)"
          :route="'lead.detail'"
        ></Barcode>
      </div>

      <!-- Title -->
      <div class="mb-2">
        <div class="grey--text text-caption-1">Name</div>
        <div class="text-body-1 font-weight-medium">
          {{ selectedLead.lead_name || "—" }}
        </div>
      </div>

      <!-- Site Location & Contact Person Row -->
      <div class="d-flex align-top">
        <!-- Site Location Block -->
        <v-card
          flat
          outlined
          class="pa-3 rounded-lg elevation-0 left-border-orange w-50 mr-3"
        >
          <div class="text-subtitle-1 orange--text font-weight-medium mb-2">
            Site Location
          </div>

          <div>
            <div class="d-flex align-center mb-1">
              <v-icon small class="mr-1">mdi-map-marker</v-icon>
              <span>{{ leadAddress() || "" }}</span>
            </div>

            <a
              v-if="leadAddress()"
              :href="
                'https://www.google.com/maps/search/?api=1&query=' +
                encodeURIComponent(leadAddress())
              "
              target="_blank"
              class="blue--text text-caption-1 mt-1 d-block"
              style="text-decoration: none"
            >
              <v-icon x-small class="mr-1" color="blue">mdi-open-in-new</v-icon>
              View on Google Maps
            </a>
          </div>
        </v-card>

        <!-- Contact Person Block -->
        <v-card
          flat
          outlined
          class="pa-3 rounded-lg elevation-0 left-border-green w-50"
        >
          <div class="text-subtitle-1 green--text font-weight-medium mb-2">
            Contact Details
          </div>
          <!-- Email -->
          <div
            v-if="selectedLead.email"
            class="d-flex align-center mb-1 cursor-pointer hover-effect"
          >
            <v-icon small class="mr-1">mdi-email</v-icon>
            <span>{{ selectedLead.email }}</span>
          </div>

          <!-- Phone -->
          <div
            v-if="selectedLead.phone_number"
            class="d-flex align-center cursor-pointer hover-effect"
          >
            <v-icon small class="mr-1">mdi-phone</v-icon>
            <span>{{ selectedLead.phone_number }}</span>
          </div>
        </v-card>
      </div>
    </template>
  </v-card>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import Barcode from "@/view/pages/partials/Barcode.vue";
import { join } from "lodash";

export default {
  name: "claim-detail",
  title: "Claim",
  mixins: [CommonMixin],
  data() {
    return {
      visitLoading: false,
    };
  },
  props: {
    selectedLead: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  components: {
    Barcode,
  },
  methods: {
    leadAddress() {
      if (this.selectedLead) {
        let leadAddress = [];
        if (this.selectedLead.unit_no) {
          leadAddress.push(this.selectedLead.unit_no);
        }
        if (this.selectedLead.address_line_1) {
          leadAddress.push(this.selectedLead.address_line_1);
        }
        if (this.selectedLead.address_line_2) {
          leadAddress.push(this.selectedLead.address_line_2);
        }
        if (this.selectedLead.postal_code) {
          leadAddress.push(this.selectedLead.postal_code);
        }
        if (this.selectedLead.country) {
          leadAddress.push(this.selectedLead.country);
        }
        return join(leadAddress, ", ");
      }
      return null;
    },
  },
};
</script>
